import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type ContainerStationReducedFragment = { __typename?: 'ContainerStation', id: string, name: string, store_id: string, status?: Types.ContainerStationStatus | null, epc_tag: string, total_stock: number, item_location_name?: string | null, item_type: { __typename?: 'ItemType', id: number, name: string, color_hex_code?: string | null, category: Types.ItemTypeCategory, epc_asset_id: number, image_url?: string | null, archived: boolean, weight: number }, store: { __typename?: 'Store', id: string, name?: string | null, brand_id?: string | null }, current_item_location?: { __typename?: 'ContainerStationItemLocationInfo', name: string } | null, stock: Array<{ __typename?: 'ContainerStationStock', id: number, name: string, image_url?: string | null, sealed: boolean }> };

export const ContainerStationReducedFragmentDoc = gql`
    fragment ContainerStationReduced on ContainerStation {
  id
  name
  store_id
  status
  item_type {
    id
    name
    color_hex_code
    category
    epc_asset_id
    image_url
    archived
    weight
  }
  epc_tag
  total_stock
  store {
    id
    name
    brand_id
  }
  current_item_location {
    name
  }
  item_location_name
  stock {
    id
    name
    image_url
    sealed
  }
}
    `;